import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>{
  text?: string | undefined
  disabledstyle?: React.CSSProperties | undefined
}

class Button extends React.Component<ButtonProps> {
  render() {
    if (!this.props.hidden)
    return (     
      <button
        {...this.props}
        style={(this.props.disabled && this.props.disabledstyle) ? this.props.disabledstyle : this.props.style}
      >
        {this.props.text}
        {this.props.children}
      </button>     
    );
  }
}

export default Button;